import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types'; // @ts-expect-error untyped dependency

import AutomationPlatformWorkflowReferenceResolver from 'reference-resolvers/resolvers/AutomationPlatformWorkflowReferenceResolver'; // @ts-expect-error untyped dependency

import { AUTOMATION_PLATFORM_WORKFLOWS } from 'reference-resolvers/constants/ReferenceObjectTypes'; // @ts-expect-error untyped dependency

import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
import WorkflowDetail from 'automation-contextual-components/components/WorkflowDetail';
import ErrorBoundary from 'automation-contextual-components/_internal/error/components/ErrorBoundary';
const WorkflowDetailListPropTypes = {
  details: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    isExternalLink: PropTypes.bool.isRequired
  })).isRequired,
  onLinkClick: PropTypes.func
};

const WorkflowDetailList = ({
  details,
  onLinkClick = () => {}
}) => {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx("div", {
      children: details.map(flow => /*#__PURE__*/_jsx(WorkflowDetail, {
        id: flow.id,
        isExternalLink: flow.isExternalLink,
        onLinkClick: onLinkClick
      }, flow.id))
    })
  });
};

WorkflowDetailList.propTypes = WorkflowDetailListPropTypes;
export default ProvideReferenceResolvers({
  [AUTOMATION_PLATFORM_WORKFLOWS]: AutomationPlatformWorkflowReferenceResolver
}, WorkflowDetailList);